import * as types from "./mutationTypes";

export default {
  [types.SET_TEAMS](state, teams) {
    state.teams = teams;
  },
  [types.CLEAR_TEAMS](state) {
    state.teams = null;
  },
  [types.SET_TEAMS_TREE](state, teams) {
    state.teamsTree = teams;
  },
  [types.CLEAR_TEAMS_TREE](state) {
    state.teamsTree = null;
  },
  [types.SET_TEAM](state, team) {
    state.team = team;
  },
  [types.CLEAR_TEAM](state) {
    state.team = null;
  },
  [types.SET_PARENT](state, parent) {
    state.team.parent_uuid = parent;
  },
  [types.SET_NAME](state, name) {
    state.team.name = name;
  },
  [types.SET_COLOR](state, color) {
    state.team.color = color;
  },
  [types.SET_PERMISSION_DISABLED](state, { resourceUUID, permissionUUID, disabled }) {
    const resourceIndex = state.team.permissions.findIndex((resource) => resource.uuid === resourceUUID);
    const permissionIndex = state.team.permissions[resourceIndex].children?.findIndex(
      (permission) => permission.uuid === permissionUUID
    );
    state.team.permissions[resourceIndex].children[permissionIndex].disable = disabled;
  },
  [types.SET_PERMISSION](state, { resourceUUID, permissionUUID, permission }) {
    const resourceIndex = state.team.permissions.findIndex((resource) => resource.uuid === resourceUUID);
    const permissionIndex = state.team.permissions[resourceIndex].children?.findIndex(
      (permission) => permission.uuid === permissionUUID
    );
    state.team.permissions[resourceIndex].children[permissionIndex].permission = permission;
  },
  [types.ADD_PERMISSION](state, { resourceUUID, permission }) {
    const resourceIndex = state.team.permissions.findIndex((resource) => resource.uuid === resourceUUID);
    state.team.permissions[resourceIndex].children.push(permission);
  },
  [types.ADD_MEMBER](state, user) {
    if (!state.team.members) {
      state.team.members = [];
    }
    state.team.members.push({
      name: user.name,
      uuid: user.uuid,
      avatar: user.avatar,
      role: user.role
    });
  },
  [types.REMOVE_MEMBER](state, userUUID) {
    state.team.members = state.team.members.filter((user) => user.uuid !== userUUID);
  }
};
